export const pageUrlSignIn = '/?page=signin';
export const portalHeaderName = 'x-ms-apim-client';
export const subscriptionKeyHeaderName = 'Ocp-Apim-Subscription-Key';
